import { useState } from "react";
import Screen from "../../components/Screen";
import { PrimaryBtn } from "../../components/Buttons";
interface NpPickSupplierMatch {
  id: string;
  name: string;
  /** 瓦斯行地址（後端 supplier_address）；沒有就不顯示 */
  area?: string;
  /** 瓦斯行聯絡電話；沒有就不顯示 */
  phone?: string;
  /** 選填：最近叫桶天數（demo 有；真後端暫無 → 不顯示） */
  lastOrderDays?: number;
}

interface NpPickSupplierProps {
  /** 已按「最近叫桶」排序的比對到瓦斯行清單 */
  matches: NpPickSupplierMatch[];
  onPick: (supplierId: string) => void;
  /** 省略＝這一頁沒有上一步（流程第一頁）→ 不顯示返回鍵。由 Onboarding 的導航堆疊 canGoBack 決定。 */
  onBack?: () => void;
}

/**
 * 傳單・無指定：一支手機在多家瓦斯行都叫過桶 → 讓客戶選所屬那家（按最近叫桶排序，預設選最近）。
 */
const NpPickSupplier = ({ matches, onPick, onBack }: NpPickSupplierProps) => {
  const [sel, setSel] = useState<string>(matches[0]?.id || "");

  return (
    <Screen
      title="找到您所屬的瓦斯行"
      subtitle="您在這幾家都叫過桶，請選擇這次要使用的瓦斯行"
      onBack={onBack}
      footer={<PrimaryBtn active={!!sel} onClick={() => sel && onPick(sel)}>就選這家</PrimaryBtn>}
    >
      <div className="flex flex-col gap-3">
        {matches.map((m, i) => {
          const on = sel === m.id;
          return (
            <button
              key={m.id}
              onClick={() => setSel(m.id)}
              className={`relative flex items-center gap-3.5 w-full text-left rounded-[14px] p-4 cursor-pointer border-[1.5px] ${
                on ? "border-[#2196f3] bg-[#EFF6FF]" : "border-[#E7ECF3] bg-white"
              }`}
            >
              <div className={`w-11 h-11 rounded-[12px] flex items-center justify-center shrink-0 ${on ? "bg-[#DCEBFF]" : "bg-[#F1F5F9]"}`}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M12 3c1.2 2.6 4 3.8 4 7.5a4 4 0 11-8 0c0-1.3.4-2.3 1.2-3.2C10.6 8.2 12 6.4 12 3z" stroke={on ? "#1D4ED8" : "#2196f3"} strokeWidth="1.8" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`text-[16px] font-extrabold ${on ? "text-[#1D4ED8]" : "text-[#0f1a35]"}`}>{m.name}</span>
                  {i === 0 && <span className="text-[10.5px] font-extrabold text-[#B45309] bg-[#FEF3C7] rounded-full px-2 py-0.5">最近</span>}
                </div>
                {(m.area || m.lastOrderDays != null) && (
                  <div className="flex items-center gap-1.5 mt-1 text-[12.5px] text-[#64748B]">
                    {m.area && <span>{m.area}</span>}
                    {m.area && m.lastOrderDays != null && <span className="text-[#CBD5E1]">·</span>}
                    {m.lastOrderDays != null && <span className="font-bold text-[#2196f3]">最近叫桶 {m.lastOrderDays} 天前</span>}
                  </div>
                )}
                {/* 聯絡電話：讓客戶在選擇前就能辨識/直接聯絡這家瓦斯行 */}
                {m.phone && (
                  <div className="mt-0.5 text-[12.5px] text-[#64748B]">{m.phone}</div>
                )}
              </div>
              <div className={`w-[24px] h-[24px] rounded-full border-[2px] flex items-center justify-center shrink-0 ${on ? "border-[#2196f3] bg-[#2196f3]" : "border-[#CBD5E1] bg-white"}`}>
                {on && <span className="text-white text-[13px] font-black">✓</span>}
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-3 text-center text-[12px] text-[#94A3B8]">依最近叫桶排序，預設為您選最近使用的那家</div>
    </Screen>
  );
};

export default NpPickSupplier;
